import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColorSchemePreference } from 'src/app/core/services/theme/theme.constants';
import { THEME_OPTIONS } from 'src/app/core/services/theme/theme-definitions';

/** Theme previews report the selection; ThemeService applies and saves it. */
@Component({
  selector: 'appearance-toggle',
  templateUrl: './appearance-toggle.component.html',
  styleUrls: ['./appearance-toggle.component.scss'],
  standalone: false
})
export class AppearanceToggleComponent {
  private static nextId = 0;

  @Input() preference: ColorSchemePreference = 'light';
  @Input() labelledBy: string;
  @Input() compact = false;

  @Output() preferenceChange = new EventEmitter<ColorSchemePreference>();

  readonly options = THEME_OPTIONS;
  readonly groupName = `appearance-${AppearanceToggleComponent.nextId++}`;
}
